/** 지금 고른 것 — 도구 안내 줄의 문구를 가른다. */
export type EditorHintTarget = 'text' | 'image' | 'group' | null;

/**
 * 스테이지 도구 줄 아래 한 줄 안내. 아무것도 고르지 않았으면 시작 방법과 정렬·반전을 쓰는 법을,
 * 고른 레이어가 있으면 그 레이어를 고치는 법을 알린다.
 */
export const editorHintOf = (target: EditorHintTarget, hasLayers: boolean): string => {
  if (target === 'text')
    return '더블클릭으로 글자를 고쳐요 · 모서리로 글자 크기, 위·아래로 세로 늘림, 양옆으로 폭을 바꿔요';
  if (target === 'image')
    return '모서리로 자유롭게(Shift 비율 유지), 가운데 핸들로 가로·세로 크기를 바꿔요 · 위 핸들로 회전';
  if (target === 'group') return '그룹은 옮기거나 정렬할 수 없고 삭제만 할 수 있어요';
  return hasLayers
    ? '상품 위 디자인을 누르면 선택돼요 · 레이어를 선택하면 정렬·반전을 쓸 수 있어요'
    : '왼쪽 [이미지 업로드]·[텍스트]로 시작해요 · 레이어를 선택하면 정렬·반전을 쓸 수 있어요';
};
